import { StorageKey, StorageType } from "./storage.default";

declare var window: Window;

export class WindowStorage {
  get type() {
    return this._type;
  }

  constructor(
    private _fn?: () => void,
    private _type: StorageType = "session",
  ) {}

  on(type: StorageType = "session") {
    if (this._type !== type) {
      this.clear(false);
    }
    this._type = type;
  }

  has(key: StorageKey): boolean {
    try {
      return !!this.storage().getItem(key.toUpperCase());
    } catch {
      console.error("Storage has");
      return false;
    }
  }
  set<T = any>(key: StorageKey, value: T): void {
    try {
      this.storage().setItem(key.toUpperCase(), JSON.stringify(value));
      this._fn?.();
    } catch {
      console.error("Storage set");
    }
  }
  get<T = any>(key: StorageKey, defaultValue?: T): T | null {
    try {
      const value = this.storage().getItem(key.toUpperCase());
      if (value != null) {
        return JSON.parse(value);
      }
    } catch {
      console.error("Storage get");
    }

    if (defaultValue) {
      return defaultValue;
    }

    return null;
  }
  remove(key: StorageKey): void {
    try {
      this.storage().removeItem(key.toUpperCase());
      this._fn?.();
    } catch {
      console.error("Storage remove");
    }
  }
  clear(all: boolean = false): void {
    try {
      if (all) {
        window!.localStorage.clear();
        window!.sessionStorage.clear();
      } else {
        this.storage().clear();
      }
      this._fn?.();
    } catch {
      console.error("Storage clear");
    }
  }

  private storage(): Storage {
    if (this._type === "local") {
      return window!.localStorage;
    } else {
      return window!.sessionStorage;
    }
  }
}
